module.exports = __webpack_public_path__ + "img/00022.03ea9a0a.webp";